import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=273c163d&scoped=true&"
import script from "./ProjectPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=273c163d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c163d",
  null
  
)

export default component.exports